<template>
  <BModal
    :model-value="modal"
    scrollable
    centered
    title="Source"
    hide-footer
    @update:modelValue="updateModal"
  >
    <template #header>
      <div
        class="d-flex align-items-center justify-content-between modal-title w-100"
      >
        <h5 class="">Source</h5>
      </div>
      <BButton variant="link" class="close" @click="updateModal(false)">
        <i class="ion ion-android-close"></i>
      </BButton>
    </template>

    <BForm>
      <div class="form-group">
        <BFormSelect
          v-model="sourceForm.type"
          :options="sourceTypes"
          class="form-select"
        >
          <template #first>
            <BFormSelectOption :value="null" disabled
              >Select source type</BFormSelectOption
            >
          </template>
        </BFormSelect>
      </div>
      <div class="form-group">
        <BFormInput
          type="text"
          v-model="sourceForm.name"
          placeholder="Name"
        ></BFormInput>
      </div>
      <div class="form-group">
        <BFormTextarea
          type="text"
          v-model="sourceForm.description"
          placeholder="Description (Optional)"
        ></BFormTextarea>
      </div>
    </BForm>

    <template #footer>
      <div class="d-flex justify-content-end">
        <BButton variant="primary" @click="handleAction" class="mr-2">{{
          sourceData && sourceData.uuid ? "Update" : "Save"
        }}</BButton>
        <BButton variant="danger" @click="updateModal(false)">Cancel</BButton>
      </div>
    </template>
  </BModal>
</template>

<script>
import {
  BModal,
  BFormInput,
  BButton,
  BForm,
  BFormTextarea,
  BFormSelect,
  BFormSelectOption,
} from "bootstrap-vue-next";
import { ref, inject, watch } from "vue";

export default {
  components: {
    BModal,
    BFormInput,
    BButton,
    BForm,
    BFormTextarea,
    BFormSelect,
    BFormSelectOption,
  },
  props: {
    modal: Boolean,
    sourceData: Object,
  },
  emits: ["update:modal"],
  setup(props, { emit }) {
    const repositories = inject("repositories");
    const sourceRepository = repositories ? repositories.source : null;

    const sourceTypes = [
      { value: "direct_booking", text: "Direct Booking" },
      { value: "booking_online", text: "Booking Online" },
      { value: "agent", text: "Agent" },
      { value: "walk_in", text: "Walk In" },
    ];

    const sourceForm = ref({
      name: "",
      type: null,
      description: "",
    });

    const updateModal = (value) => {
      emit("update:modal", value); // Sync modal state with parent
    };

    const handleAction = () => {
      props.sourceData.uuid ? update() : create();
    };

    const create = async () => {
      await sourceRepository
        .create(sourceForm.value)
        .then(() => {
          updateModal(false);
          sourceForm.value = {};
          emit("addOrUpdate");
        })
        .catch((err) => {
          console.error(err);
        });
    };

    const update = async () => {
      await sourceRepository
        .update(sourceForm.value, props.sourceData.uuid)
        .then(() => {
          updateModal(false);
          sourceForm.value = {};
          emit("addOrUpdate");
        })
        .catch((err) => {
          console.error(err);
        });
    };

    watch(
      () => props.sourceData,
      (newData) => {
        if (newData) {
          sourceForm.value = { ...newData };
        }
      },
      { immediate: true }
    );

    return {
      sourceForm,
      updateModal,
      handleAction,
      create,
      update,
      sourceTypes,
    };
  },
};
</script>
